import { useState } from 'react';
import { Modal } from '../../../../views';
import { GhostButton, TextField } from '../../components';
import { Module1Exercise1ThoughtList } from './Module1Exercise1ThoughtList';

type Props = {
    type: 'negative' | 'positive';
    items: string[];
    onItemAdded: (text: string) => void;
    onClose: () => void;
};
export function Module1Exercise1Popup({
    type,
    items,
    onItemAdded,
    onClose,
}: Props) {
    const [text, setText] = useState<string | null>(null);
    return (
        <Modal title={null} onClose={onClose} fullscreen>
            <Module1Exercise1ThoughtList
                className="m-20"
                type={type}
                items={items}
            >
                {text == null ? (
                    <GhostButton onClick={() => setText('')} class="mt-10">
                        Tilføj mere
                    </GhostButton>
                ) : (
                    <>
                        <form
                            onSubmit={() => {
                                onItemAdded(text);
                                setText(null);
                            }}
                        >
                            <TextField
                                text={text}
                                onChangeText={setText}
                                placeholder="F.eks. At tale med min ven"
                                margin="mb-20 mt-10"
                            />
                            <GhostButton type="submit">Gem</GhostButton>
                        </form>
                    </>
                )}
            </Module1Exercise1ThoughtList>
        </Modal>
    );
}
